module.exports = __webpack_public_path__ + "img/ic_qmarker_handwash_lbl.c2ede314.png";